/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { FilterIn } from './filterIn';
import type { SortIn } from './sortIn';

export interface QueryIn {
  project_id?: string | null;
  job_id?: string | null;
  job_candidate_id?: string | null;
  employer_id?: string | null;
  /** @maxItems 20 */
  filters?: FilterIn[];
  attention?: string | null;
  sort?: SortIn | null;
  /** @minimum 1 */
  page?: number;
  /**
     * @minimum 1
     * @maximum 100
     */
  per_page?: number;
  columns_version?: string | null;
}
